import React from 'react'
import { useTranslation } from 'react-i18next'
import { findSubscriptionPeriodCloseToDate } from '../../utils/warrants'
import { formatMoney } from '../../packages/utils/numberFormatters'

function NewsHeadlineTerms({ row }) {
    const { entityType, companyName, issueData, warrantData } = row
    const { i18n, t } = useTranslation()
    const locale = i18n.language

    if (entityType === 'Warrant') {
        const subscriptionPeriod = findSubscriptionPeriodCloseToDate(
            { subscriptionPeriods: warrantData.subscriptionPeriods },
            new Date().toISOString(),
        )
        return (
            <span>
                {companyName} offentliggör teckningskurs{' '}
                {formatMoney(subscriptionPeriod.warrantSubPrice, {
                    minDecimals: 2,
                    maxDecimals: 5,
                    locale,
                })}{' '}
                {row.currency} för {row.name || warrantData.name}
            </span>
        )
    }

    return (
        <span>
            {companyName} offentliggör villkor för tidigare aviserad{' '}
            {t(`entities.issueType.values.${issueData.type}`).toLowerCase()}
        </span>
    )
}

export default NewsHeadlineTerms
